import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=6908234d"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6908234d')) {
      api.createRecord('6908234d', component.options)
    } else {
      api.reload('6908234d', component.options)
    }
    module.hot.accept("./ContentFooter.vue?vue&type=template&id=6908234d", function () {
      api.rerender('6908234d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/dashboard/ContentFooter.vue"
export default component.exports